import React from 'react'

const SingleRoomContext = React.createContext()

export default SingleRoomContext